/* MyKidss fixed free-shipping thresholds by presentment currency. Test theme only. */
(function () {
  function thresholdForCurrency(currency) {
    var code = String(currency || '').toUpperCase();
    if (code === 'PLN') return 250;
    if (code === 'EUR') return 100;

    var baseRate = Number(typeof currencyRate !== 'undefined' ? currencyRate : 0);
    var fxRate = window.Shopify && Shopify.currency && Number(Shopify.currency.rate)
      ? Number(Shopify.currency.rate)
      : 1;

    return baseRate > 0 ? Math.round(baseRate * fxRate) : 0;
  }

  window.shippingProgressBar = function (totalprice) {
    // Danish market uses DKK; the shipping rule is 100 EUR, converted at
    // Shopify's current presentment rate. Never guess a DKK threshold.
    var isDanishStorefront = /^\/da-dk(?:\/|$)/i.test(window.location.pathname || '')
      || /^da(?:-|$)/i.test(document.documentElement.lang || '');
    if (isDanishStorefront) {
      var dkBars = document.querySelectorAll('[data-shipping-bar-wrapper]');
      var dkNotes = document.querySelectorAll('[data-dk-shipping-static]');
      var currentCurrency = window.Shopify && Shopify.currency
        ? String(Shopify.currency.active || '').toUpperCase()
        : '';
      var rate = window.Shopify && Shopify.currency
        ? Number(Shopify.currency.rate)
        : 0;

      // If no reliable conversion is available, the safe factual message
      // remains visible and no percentage or misleading promise is shown.
      if (!dkBars.length || currentCurrency !== 'DKK' ||
          !Number.isFinite(rate) || rate <= 2) {
        dkBars.forEach(function (dkBar) {
          dkBar.classList.add('hidden');
          dkBar.style.display = 'none';
          dkBar.setAttribute('aria-hidden', 'true');
        });
        dkNotes.forEach(function (dkNote) {
          dkNote.hidden = false;
          dkNote.style.display = '';
        });
        return;
      }

      var thresholdDKK = 100 * rate;
      var cartDKK = Number(totalprice || 0) / 100;
      var achieved = cartDKK >= thresholdDKK;
      var percent = Math.max(0, Math.min(100,
        Math.floor(100 * cartDKK / thresholdDKK)));
      var formatter = new Intl.NumberFormat('da-DK', {
        style: 'currency', currency: 'DKK', maximumFractionDigits: 0
      });
      var needed = formatter.format(Math.ceil(Math.max(0, thresholdDKK - cartDKK)));
      var danishMessage = achieved
        ? 'Du har opnået gratis standardlevering!'
        : 'Du mangler ca. ' + needed + ' for at få gratis standardlevering.';
      dkBars.forEach(function (dkBar) {
        var dkMessage = dkBar.querySelector('.free-shipping-message');
        var dkProgress = dkBar.querySelector('[data-shipping-bar]');
        var dkBadge = dkBar.querySelector('[data-shipping-percentage]');
        if (dkMessage) dkMessage.textContent = danishMessage;
        if (dkProgress) dkProgress.style.width = percent + '%';
        if (dkBadge) dkBadge.textContent = percent + '%';
        dkBar.classList.toggle('is-complete', achieved);
        dkBar.classList.remove('hidden');
        dkBar.style.display = '';
        dkBar.setAttribute('aria-hidden', 'false');
      });
      dkNotes.forEach(function (dkNote) {
        dkNote.hidden = true;
        dkNote.style.display = 'none';
      });
      return;
    }
    if (typeof shippingStatus === 'undefined' || shippingStatus !== true) return;

    var currency = window.Shopify && Shopify.currency && Shopify.currency.active
      ? Shopify.currency.active
      : '';
    var threshold = thresholdForCurrency(currency);
    if (!threshold) return;

    var total = Number(totalprice || 0) / 100;
    var shippingText = '';

    if (total < threshold) {
      var missing = (threshold - total).toFixed(2);
      var priceMessage = missing + ' ' + currency;
      shippingText = typeof shippingmessage !== 'undefined'
        ? shippingmessage.replace('||price||', priceMessage)
        : priceMessage;
    } else {
      shippingText = typeof shippingsuccessmessage !== 'undefined'
        ? shippingsuccessmessage
        : '';
    }

    var percentage = (total * 100) / threshold;
    if (percentage > 10 && percentage < 100) {
      percentage -= 5;
    } else if (percentage > 100) {
      percentage = 100;
    }
    percentage = Math.max(0, Math.min(100, Math.trunc(percentage)));

    var wrapper = document.querySelector('[data-shipping-bar-wrapper]');
    if (!wrapper) return;

    wrapper.classList.remove('hidden');

    var message = wrapper.querySelector('.free-shipping-message');
    var bar = wrapper.querySelector('[data-shipping-bar]');
    var badge = wrapper.querySelector('[data-shipping-percentage]');

    if (message) message.textContent = shippingText;
    if (bar) bar.style.width = percentage + '%';
    if (badge) badge.textContent = percentage + '%';
  };

  function refreshFromCart() {
    if (typeof shippingProgressBar !== 'function') return;
    var isDanish = /^\/da-dk(?:\/|$)/i.test(window.location.pathname || '')
      || /^da(?:-|$)/i.test(document.documentElement.lang || '');
    var shopRoot = window.Shopify && Shopify.routes && Shopify.routes.root
      ? String(Shopify.routes.root)
      : '/da-dk/';
    var cartUrl = isDanish ? shopRoot.replace(/\/?$/, '/') + 'cart.js' : '/cart.js';
    fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { shippingProgressBar(cart.total_price); })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.setTimeout(refreshFromCart, 80);
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-button], cart-drawer, .cart-drawer-button')) {
      window.setTimeout(refreshFromCart, 650);
    }
  });
})();
